/**
 * Scheduled updates module
 *
 * @author Ryan Zhang (rzhang@yext.com)
 */
goog.provide('yext.scheduledupdates');
goog.provide('yext.scheduledupdates.FutureDate');

goog.require('yext.scheduledupdates.dialog.CancelDialog');
goog.require('yext.scheduledupdates.dialog.RescheduleDialog');
goog.require('yext.scheduledupdates.dialog.NewDateDialog');
goog.require('yext.scheduledupdates.routes');
goog.require('yext.time');
goog.require('yext');

/**
 * Initialize the module
 *
 * @param {!jQuery} $container The container element of the scheduled updates sidebar
 */
yext.scheduledupdates.init = function($container) {
  new yext.scheduledupdates.ScheduledUpdatesSidebar($container);
  yext.scheduledupdates.routes.init();
};

/**
 * @param {!jQuery} $container The container element of the scheduled updates sidebar
 * @constructor
 */
yext.scheduledupdates.ScheduledUpdatesSidebar = function($container) {
  this.$container = $container;
  this.$addDateDialog = $('.js-schedule-new-update-dialog');

  this.futureDates = [];

  this.bindAddDate();
  this.bindFutureDates();
  this.bindFieldRowTooltips();
};

/**
 * Binds click handler on add date link. When a new date is selected, the page is refreshed
 *
 * with the date appended as a url param.
 */
yext.scheduledupdates.ScheduledUpdatesSidebar.prototype.bindAddDate = function() {
  var self = this;
  this.$container.find('.js-show-add-scheduled-update').on('click', function() {
    var options = {
      container: self.addDateDialog,
    };
    yext.scheduledupdates.dialog.NewDateDialog(options).show();
  });

  var $addDateDialog = this.$addDateDialog;
  this.$addDateDialog.on('submit', function(e, selectedDate) {
    var params = yext.getUrlParams();
    params.date = window.encodeURI(yext.time.formatDateIso(selectedDate));
    window.location.href = yext.buildUrlWithParams(window.location.href.split('?')[0], params);
  });
};

/**
 * Builds up the models for all the future date rows on the sidebar.
 */
yext.scheduledupdates.ScheduledUpdatesSidebar.prototype.bindFutureDates = function() {
  var self = this;
  var $actions = this.$container.find('.js-scheduled-updates-actions');
  this.$container.find('.js-scheduled-update-date-wrap').each(function() {
    var $perDateAction = $actions.clone().appendTo(self.$container);
    var futureDate = new yext.scheduledupdates.FutureDate($(this), self, $perDateAction);
    self.futureDates.push(futureDate);
  });
};

/**
 * Bind schedule update tooltips for field rows that describe if a field does not support scheduled updates.
 */
yext.scheduledupdates.ScheduledUpdatesSidebar.prototype.bindFieldRowTooltips = function() {
  var tooltipOptions = {
    event: 'hover',
    location: 'right',
    hoverDelay: 300,
    fadeDuration: 300,
    propagate: true,
    contentElement: '.js-schedule-updates-prohibited-tooltip',
  };
  $('.js-schedule-updates-prohibited-field').contextualHelp(tooltipOptions);
};

/**
 * Closes / hides the actions dropdowns for all future dates in this sidebar.
 */
yext.scheduledupdates.ScheduledUpdatesSidebar.prototype.closeAllFutureDateOptions = function() {
  this.futureDates.forEach(function(futureDate) {
    futureDate.closeActions();
  });
};

/**
 * @param {!jQuery} $element  The element for a future date
 * @param {!Object} sidebar         The sidebar that these future dates are in
 * @param {!jQuery} $actions  The actions for each future date
 * @constructor
 */
yext.scheduledupdates.FutureDate = function($element, sidebar, $actions) {
  this.$element = $element;
  // TODO (mkintali): This isn't the right format of the date to be shown on the dialog
  // or the sidebar according to the spec but maybe it's ok, will need to confirm with Product.
  this.date = $element.data('date');
  this.$showActions = $element.find('.js-show-scheduled-update-date-options');
  this.$actions = $actions;

  // TODO (mkintali): Do something with this action...
  var self = this;
  var cancelAction = yext.scheduledupdates.ScheduledUpdateAction(
    self.$actions.find('.js-cancel-updates'),
    (function() {
      // TODO (mkintali): Need to figure out the rest of the data.
      var cancelDialog = new yext.scheduledupdates.dialog.CancelDialog(self.date);
      cancelDialog.show();
      self.closeActions();
    }));

  var rescheduleAction = yext.scheduledupdates.ScheduledUpdateAction(
    self.$actions.find('.js-reschedule-updates'),
    (function() {
      var rescheduleDialog = new yext.scheduledupdates.dialog.RescheduleDialog(self.date);
      rescheduleDialog.show();
      self.closeActions();
    }));
  this.sidebar = sidebar;
  this.bindShowActions();
};

/**
 * Binds the actions dropdown for this FutureDate. It changes the visibility.
 */
yext.scheduledupdates.FutureDate.prototype.bindShowActions = function() {
  var self = this;
  this.$showActions.on('click', function() {
    var visible = self.$actions.is(':visible');
    self.sidebar.closeAllFutureDateOptions();
    if (!visible) {
      self.$actions.show();
      self.$element.addClass('active');
      self.$actions.addClass('active');
      self.$actions.position({
        my: 'right top',
        at: 'right bottom',
        offset: '0 2',
        collision: 'flip',
        of: self.$showActions,
      });
    }
  });
};

/**
 * Closes the actions dropdown for this FutureDate
 */
yext.scheduledupdates.FutureDate.prototype.closeActions = function() {
  this.$actions.hide();
  this.$element.removeClass('active');
  this.$actions.removeClass('active');
};

/**
 * @param {!jQuery} $element           The element of this action.
 * @param {*}            onClick            The onClick method.
 * @constructor
 */
yext.scheduledupdates.ScheduledUpdateAction = function($element, onClick) {
  this.$element = $element;
  this.$element.click(onClick);
};

/**
 * Bind reschedule update and cancel update links to the proper actions.
 * Not all field names / custom field ids are known at the time of the call to this method,
 * therefore provider functions are required.
 *
 * @param {function(): String}   fieldNameProvider
 * @param {function(): int}      customFieldIdProvider
 * @param {!jQuery}         $scheduledUpdateActions the div containing the cancel and reschedule links
 * @param {string}               profileDate string representing the current date of the profile
 *                               (if not provided, the date is parsed from the URL)
 */
yext.scheduledupdates.bindScheduledUpdateActions =
    function(fieldNameProvider, customFieldIdProvider, $scheduledUpdateActions, profileDate) {
      if (!profileDate) {
        profileDate = yext.getUrlParams().date;
      }

      $scheduledUpdateActions.find('.js-cancel-scheduled-update').unbind().on('click', function(e) {
        var cancelDialog = new yext.scheduledupdates.dialog.CancelDialog(profileDate, fieldNameProvider(), customFieldIdProvider());
        cancelDialog.show();
        e.stopPropagation();
      });

      $scheduledUpdateActions.find('.js-reschedule-scheduled-update').unbind().on('click', function(e) {
        var rescheduleDialog = new yext.scheduledupdates.dialog.RescheduleDialog(profileDate, fieldNameProvider(), customFieldIdProvider());
        rescheduleDialog.show();
        e.stopPropagation();
      });
    };
